import { memo } from 'react';
import { Flow } from '@thive/fddm-types';

import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { useOrderProfileStore } from '@/modules/orderProfile/store/useOrderProfileStore';
import { NumberInput } from '@/modules/common/components/inputs';

import { useFlowUpdaters } from '../hooks/useFlowUpdaters';
import { FlowGraph, LoadPerHourInput } from '.';
import { PreAnnouncementInput } from './PreAnnouncementInput';

interface Props {
  id: string;
  disabled: boolean;
  flow: Flow;
}

function TransportPropertiesComponent({ id, disabled, flow }: Props) {
  const { onFlowVehicleLimitChange } = useFlowUpdaters(id);
  const { hourlyOrderCounts, vehicleLimit, transportExtension } = flow;
  const value = hourlyOrderCounts[0];
  const { orderProfile } = useOrderProfileStore();

  return (
    <>
      {orderProfile ? (
        <FlowGraph hourlyOrderCounts={hourlyOrderCounts} />
      ) : (
        <PropertiesLabel
          labelRatio={70}
          i18nkey='interface:properties.flows.flow_info.total_loads.label'
        >
          <LoadPerHourInput id={id} totalNumLoads={value} disabled={disabled} />
        </PropertiesLabel>
      )}
      <PreAnnouncementInput
        id={id}
        sourceAreaOrFlowStopId={flow.sourceAreaOrFlowStopId}
        preAnnounceDuration={transportExtension?.preAnnounceDuration ?? 0}
        maxActivePreAnnouncedAvOrders={transportExtension?.maxActivePreAnnouncedAvOrders ?? 1}
        disabled={disabled}
      />
      <PropertiesLabel labelRatio={70} skipFocus i18nkey='interface:properties.highway.vehicles'>
        <NumberInput
          value={vehicleLimit}
          onChange={onFlowVehicleLimitChange}
          clearButton={{
            text: 'All',
            value: -1,
          }}
          sx={{ width: '100%', float: 'right' }}
          disabled={disabled}
        />
      </PropertiesLabel>
    </>
  );
}

export const TransportProperties = memo(TransportPropertiesComponent);
